import { render, staticRenderFns } from "./carouselSection.vue?vue&type=template&id=b1e16284&scoped=true&"
import script from "./carouselSection.vue?vue&type=script&lang=js&"
export * from "./carouselSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e16284",
  null
  
)

export default component.exports